/**
 * useDriveConnected — true once this person's Google Drive is connected.
 *
 * Surfaces that grow a Drive affordance ask here first, so a tenant that has
 * the connector available but a user who never linked an account sees exactly
 * the interface they saw before. Answers `false` until the one cached request
 * resolves, and never fires at all while `enabled` is false.
 */

import { useEffect, useState } from 'react';
import { driveConnected } from '../services/driveService';

export function useDriveConnected(enabled: boolean): boolean {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setConnected(false);
      return;
    }
    let cancelled = false;
    void driveConnected().then((yes) => { if (!cancelled) setConnected(yes); });
    return () => { cancelled = true; };
  }, [enabled]);

  return connected;
}
